import { hotRanks } from "@/mocks/guaData";

const levelColor: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-accent-500 text-background-50",
  新: "bg-secondary-200 text-secondary-800",
};

export default function HotRanks() {
  return (
    <section id="hot" className="relative -mt-6 md:-mt-10 z-20 px-4 md:px-8 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden shadow-sm">
          <div className="grid lg:grid-cols-12 gap-0">
            {/* left title block */}
            <div className="lg:col-span-3 p-6 md:p-8 bg-primary-500 text-background-50 flex flex-col justify-between">
              <div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium">
                  <i className="ri-time-line"></i> 每日 20:00 更新
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold mt-4 leading-snug">
                  今日热榜
                  <br />
                  TOP 6
                </h2>
                <p className="text-background-50/85 text-sm mt-3 leading-relaxed">
                  编辑部为你挑选当天最值得吃的瓜，进度、反转与实锤都标注清楚，一次看全。
                </p>
              </div>
              <div className="mt-6 flex items-end gap-6 text-background-50">
                <div>
                  <p className="font-heading text-2xl md:text-3xl font-bold">328</p>
                  <p className="text-xs text-background-50/80 mt-1">今日更新篇数</p>
                </div>
                <div>
                  <p className="font-heading text-2xl md:text-3xl font-bold">18.6亿</p>
                  <p className="text-xs text-background-50/80 mt-1">累计热度曝光</p>
                </div>
              </div>
            </div>

            {/* right list */}
            <div className="lg:col-span-9 divide-y divide-background-200/70">
              {hotRanks.map((item) => (
                <a
                  key={item.rank}
                  href="#content"
                  className="group flex items-center gap-4 md:gap-6 px-5 md:px-7 py-4 hover:bg-background-100 transition-colors"
                >
                  <span className="font-heading text-2xl md:text-4xl font-black w-10 text-center shrink-0 tabular-nums text-foreground-200 group-hover:text-primary-500 transition-colors">
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className={`px-2 py-0.5 rounded text-[11px] font-semibold ${levelColor[item.level]}`}>
                        {item.level}
                      </span>
                      <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-medium text-foreground-950 text-[15px] md:text-base mt-1.5 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
                      {item.title}
                    </h3>
                  </div>
                  <span className="hidden sm:inline-flex items-center text-foreground-400 text-sm whitespace-nowrap">
                    {item.delta === "up" && <i className="ri-arrow-up-line text-primary-500 mr-1"></i>}
                    {item.delta === "down" && <i className="ri-arrow-down-line text-secondary-400 mr-1"></i>}
                    {item.delta === "new" && <span className="text-accent-600">新进</span>}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}